module.exports = __webpack_public_path__ + "img/kefu.f818cea4.jpg";